import axios from 'axios';
import toast from 'react-hot-toast';

const API_BASE_URL = 'https://api.vicharmedia24.com/api';
//const API_BASE_URL = 'http://103.99.37.61:5900/api';


export const BASE_URL ='https://api.vicharmedia24.com'
//export const BASE_URL ='http://103.99.37.61:5900'

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
  

// Request interceptor - Add authentication token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors and authentication
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      // window.location.href = '/login';
      toast.error('Session expired. Please login again.');
      setTimeout(()=>{
        window.location.href = '/login';
      },2000);
      return Promise.reject(error);
    }

    const message = error.response?.data?.message || 'An error occurred';
    toast.error(message);
    return Promise.reject(error);
  }
);

// Authentication API
export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  getCurrentUser: () => api.get('/auth/me'),
  changePassword: (data) => api.post('/auth/change-password', data),
  logout: () => api.post('/auth/logout')
};

// News Categories API
export const newsCategoriesAPI = {
  getAll: () => api.get('/news-categories'),
  getById: (id) => api.get(`/news-categories/${id}`),
  create: (data) => api.post('/news-categories', data),
  update: (id, data) => api.put(`/news-categories/${id}`, data),
  delete: (id) => api.delete(`/news-categories/${id}`)
};

// Breaking News API
export const breakingNewsAPI = {
  getAll: () => api.get('/breaking-news'),
  getById: (id) => api.get(`/breaking-news/${id}`),
  create: (formData) => api.post('/breaking-news', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, formData) => api.put(`/breaking-news/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => api.delete(`/breaking-news/${id}`)
};

// Trending News API
export const trendingNewsAPI = {
  getAll: () => api.get('/trending-news'),
  getById: (id) => api.get(`/trending-news/${id}`),
  create: (formData) => api.post('/trending-news', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, formData) => api.put(`/trending-news/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => api.delete(`/trending-news/${id}`)
};

// General News API
export const newsAPI = {
  getAll: () => api.get('/news'),
  getById: (id) => api.get(`/news/${id}`),
  create: (formData) => api.post('/news', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, formData) => api.put(`/news/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => api.delete(`/news/${id}`)
};

// Advertisements API
export const advertisementsAPI = {
  getAll: () => api.get('/advertisements'),
  getActive: () => api.get('/advertisements/active'),
  getById: (id) => api.get(`/advertisements/${id}`),
  create: (formData) => api.post('/advertisements', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, formData) => api.put(`/advertisements/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  toggleStatus: (id) => api.patch(`/advertisements/${id}/toggle-status`),
  delete: (id) => api.delete(`/advertisements/${id}`)
};

export default api;
















































// import axios from 'axios';
// import toast from 'react-hot-toast';

// //const API_BASE_URL = 'https://api.vicharmedia24.com/api';
// const API_BASE_URL = 'http://localhost:5900/api';


// //export const BASE_URL ='https://api.vicharmedia24.com'
// export const BASE_URL ='http://localhost:5900'

// // Create axios instance
// const api = axios.create({
//   baseURL: API_BASE_URL,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Request interceptor
// api.interceptors.request.use(
//   (config) => {
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Response interceptor
// api.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     const message = error.response?.data?.message || 'An error occurred';
//     toast.error(message);
//     return Promise.reject(error);
//   }
// );




// // News Categories API
// export const newsCategoriesAPI = {
//   getAll: () => api.get('/news-categories'),
//   getById: (id) => api.get(`/news-categories/${id}`),
//   create: (data) => api.post('/news-categories', data),
//   update: (id, data) => api.put(`/news-categories/${id}`, data),
//   delete: (id) => api.delete(`/news-categories/${id}`)
// };

// // Breaking News API
// export const breakingNewsAPI = {
//   getAll: () => api.get('/breaking-news'),
//   getById: (id) => api.get(`/breaking-news/${id}`),
//   create: (formData) => api.post('/breaking-news', formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   update: (id, formData) => api.put(`/breaking-news/${id}`, formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   delete: (id) => api.delete(`/breaking-news/${id}`)
// };

// // Trending News API
// export const trendingNewsAPI = {
//   getAll: () => api.get('/trending-news'),
//   getById: (id) => api.get(`/trending-news/${id}`),
//   create: (formData) => api.post('/trending-news', formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   update: (id, formData) => api.put(`/trending-news/${id}`, formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   delete: (id) => api.delete(`/trending-news/${id}`)
// };

// // General News API
// export const newsAPI = {
//   getAll: () => api.get('/news'),
//   getById: (id) => api.get(`/news/${id}`),
//   create: (formData) => api.post('/news', formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   update: (id, formData) => api.put(`/news/${id}`, formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   delete: (id) => api.delete(`/news/${id}`)
// };

// // Advertisements API
// export const advertisementsAPI = {
//   getAll: () => api.get('/advertisements'),
//   getActive: () => api.get('/advertisements/active'),
//   getById: (id) => api.get(`/advertisements/${id}`),
//   create: (formData) => api.post('/advertisements', formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   update: (id, formData) => api.put(`/advertisements/${id}`, formData, {
//     headers: { 'Content-Type': 'multipart/form-data' }
//   }),
//   toggleStatus: (id) => api.patch(`/advertisements/${id}/toggle-status`),
//   delete: (id) => api.delete(`/advertisements/${id}`)
// };

// export default api;

